import { FieldArray } from 'formik';
import React, {useState, useEffect} from 'react';
import lodash from 'lodash';
import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import PerfectScrollBar from 'react-perfect-scrollbar';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import SearchableListingModal from '../modal/SearchableListingModal';
import { InputErrorMessage } from '../withInputErrorMessage';

const boxStyles = {
   maxHeight: '88px',
   overflowY: 'hidden',
};

const MultiSelectFieldArrayWithModal = (props) => {
   const [isOpen, setIsOpen] = useState(false);
   const [selectedValues, setSelectedValues] = useState([]);
   const [indexedName, setIndexedName] = useState([]);

   useEffect(() => {
      if (props.name.split('.').length > 1) {
         setIndexedName(props.name.split('.'));
      }
   }, [setIndexedName, props.name]);

   const itemInValues = (itemId, currentValues) => {
      if (!currentValues) {
         return false;
      }
      for (let i = 0; i < currentValues.length; i++) {
         if (`${ currentValues[i].id }` === `${ itemId }`) {
            return true;
         }
      }
      return false;
   };

   return (
      <FieldArray
         name={props.name}
         render={(arrayHelpers) => {
            const errorMessage = indexedName.length === 3
               ? arrayHelpers?.form?.errors?.[indexedName[0]]?.[indexedName[1]]?.[indexedName[2]]
               : arrayHelpers?.form?.errors?.[props.name];

            const valueFromForm = indexedName.length === 3
               ? arrayHelpers?.form?.values?.[indexedName[0]]?.[indexedName[1]]?.[indexedName[2]]
               : arrayHelpers?.form?.values?.[props.name];

            const toggle = (selectedItems) => {
               const isAllSelected = selectedItems?.find((i) => +(i?.id) === -1);

               if (isAllSelected) {
                  // Removes all other selected values and use "All keyword" as selected value
                  const resetValue = { ...arrayHelpers.form?.values };
                  if (indexedName.length === 3) {
                     resetValue[indexedName[0]][indexedName[1]][indexedName[2]] = [selectedItems[0]];
                  } else {
                     resetValue[arrayHelpers.name] = [selectedItems[0]];
                  }
                  props.setValues(resetValue);
               } else if (selectedItems.length > 0) {
                  const allKeywordIndex = valueFromForm?.findIndex((i) => +(i?.id) === -1);
                  if (allKeywordIndex !== -1 && selectedItems.length > 0) {
                     arrayHelpers.remove(allKeywordIndex);
                  }

                  for (let i = 0; i < selectedItems.length; i++) {
                     if (!itemInValues(selectedItems[i].id, valueFromForm)) {
                        arrayHelpers.push(selectedItems[i]);
                     }
                  }
               }
               setIsOpen(false);
            };

            const openModal = () => {
               setSelectedValues(valueFromForm || []);
               setIsOpen(true);
            };

            return (
               <>
                  <InputGroup>
                     <PerfectScrollBar
                        className={`form-control h-auto ${ errorMessage ? 'is-invalid' : '' }`}
                        style={boxStyles}
                     >
                        {
                           lodash.isArray(valueFromForm)
                           && (
                              valueFromForm.map((item, idxItem) => {
                                 return (
                                    <Chip
                                       clickable
                                       key={`${ item.id }`}
                                       size='small'
                                       label={item?.label}
                                       onDelete={() => {
                                          arrayHelpers.remove(idxItem);
                                       }}
                                       className='mx-1 my-1'
                                    />
                                 );
                              })
                           )
                        }
                     </PerfectScrollBar>
                     <InputGroupAddon addonType='append' onClick={openModal}>
                        <InputGroupText>+</InputGroupText>
                     </InputGroupAddon>
                     <SearchableListingModal
                        isOpen={isOpen}
                        toggle={toggle}
                        {...props.modalConfig}
                        rawResourceData={props.rawResourceData}
                        selectedValuesFromField={selectedValues}
                        valueFromForm={valueFromForm}
                        push={arrayHelpers.push}
                        pop={arrayHelpers.pop}
                     />
                  </InputGroup>
                  <InputErrorMessage
                     isErrorVisible={!!errorMessage}
                     errorMessage={errorMessage}
                  />
               </>
            );
         }}
      />
   );
};

MultiSelectFieldArrayWithModal.propTypes = {
   name: PropTypes.string.isRequired,
   modalConfig: PropTypes.shape({
      title: PropTypes.string.isRequired,
      resource: PropTypes.string.isRequired,
      fetchResource: PropTypes.func.isRequired,
      resourceMiddleWare: PropTypes.func.isRequired,
   }).isRequired,
   rawResourceData: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool,
   ]),
};

MultiSelectFieldArrayWithModal.defaultProps = {
   rawResourceData: false,
};

export default MultiSelectFieldArrayWithModal;
